import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { Contrato } from './components/Contrato';

export default function ContratoCreation() {
    return (
        <MainContent
            component={<Contrato />}
            titulo='Detalle de contrato'
            noBackground
            tableMaxWidth
        />
    );

};
